import { ChevronLeft, ChevronRight } from 'lucide-react';

export function Pagination({
  page,
  pageSize,
  total,
  onPage,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (next: number) => void;
}) {
  const last = Math.max(1, Math.ceil(total / pageSize));
  if (total === 0) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="flex items-center justify-between mt-3 px-1 text-sm text-text2">
      <div>
        Showing <span className="text-text">{from.toLocaleString()}</span>–
        <span className="text-text">{to.toLocaleString()}</span> of{' '}
        <span className="text-text">{total.toLocaleString()}</span>
      </div>
      <div className="flex items-center gap-1">
        <button
          className="ad-btn-secondary ad-btn-sm disabled:opacity-40"
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
        >
          <ChevronLeft size={14} /> Prev
        </button>
        <div className="px-2">
          {page} / {last}
        </div>
        <button
          className="ad-btn-secondary ad-btn-sm disabled:opacity-40"
          disabled={page >= last}
          onClick={() => onPage(page + 1)}
        >
          Next <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
